import React from 'react';
import Link from 'next/link';
import { Star } from 'lucide-react';
import { ACHIEVEMENTS } from '@/lib/mockData';

const rarityColors: Record<string, string> = {
  legendary: '#f59e0b',
  epic: '#a855f7',
  rare: '#06b6d4',
  common: '#6b7280',
};

const rarityBg: Record<string, string> = {
  legendary: 'rgba(245, 158, 11, 0.1)',
  epic: 'rgba(168, 85, 247, 0.1)',
  rare: 'rgba(6, 182, 212, 0.1)',
  common: 'rgba(107, 114, 128, 0.1)',
};

const latest = [...ACHIEVEMENTS].sort((a, b) => b.unlockedAt.localeCompare(a.unlockedAt)).slice(0, 5);

export default function LatestAchievements() {
  return (
    <div>
      <div className="flex items-center justify-between mb-5">
        <div className="flex items-center gap-3">
          <div className="p-2 rounded-lg" style={{ background: 'rgba(245, 158, 11, 0.1)' }}>
            <Star size={18} style={{ color: '#f59e0b' }} />
          </div>
          <div>
            <h2 className="text-lg font-bold" style={{ color: 'var(--foreground)' }}>
              Latest Achievements
            </h2>
            <p className="text-xs" style={{ color: 'var(--muted-foreground)' }}>
              Recently unlocked
            </p>
          </div>
        </div>
        <Link
          href="/hall-of-fame"
          className="text-xs font-semibold transition-colors hover:opacity-80"
          style={{ color: 'var(--primary)' }}
        >
          View all →
        </Link>
      </div>

      <div className="space-y-2.5">
        {latest.map((ach) => (
          <Link
            href="/hall-of-fame"
            key={`latest-ach-${ach.id}`}
            className="flex items-center gap-3 p-3.5 rounded-xl transition-all duration-200 hover:scale-[1.01] group"
            style={{
              background: 'var(--muted)',
              border: '1px solid var(--border)',
            }}
          >
            {/* Icon */}
            <div
              className="w-10 h-10 rounded-xl flex items-center justify-center text-xl flex-shrink-0"
              style={{ background: rarityBg[ach.rarity], border: `1px solid ${rarityColors[ach.rarity]}30` }}
            >
              {ach.icon}
            </div>

            {/* Info */}
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 mb-0.5">
                <p className="text-sm font-bold truncate" style={{ color: 'var(--foreground)' }}>
                  {ach.title}
                </p>
                <span
                  className="text-xs font-semibold px-1.5 py-0.5 rounded capitalize flex-shrink-0"
                  style={{
                    background: rarityBg[ach.rarity],
                    color: rarityColors[ach.rarity],
                  }}
                >
                  {ach.rarity}
                </span>
              </div>
              <p className="text-xs truncate" style={{ color: 'var(--muted-foreground)' }}>
                {ach.displayName} · {ach.stat} {ach.statLabel}
              </p>
            </div>

            {/* Date */}
            <div className="text-right flex-shrink-0">
              <p className="text-xs font-medium" style={{ color: 'var(--muted-foreground)' }}>
                {ach.unlockedAt}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}